import { UiMessageBubbleStoreContext } from "./_sotre/UiMessageBubbleStore";
import { receivedBubbleStyles, sentBubbleStyles } from "./styles";
import { Loading } from "@/components/ui/loading";
import { MessagingStatus } from "@/model/messaging";
import { cn } from "@deputy-ai/common";
import { useAtomValues } from "@deputy-ai/common/jotai";
import { MdError } from "react-icons/md";

export function UiMessageBubbleStatus() {
  const {
    propsAtoms,
    callbacks: { onResendMessage },
  } = UiMessageBubbleStoreContext.useStore();
  const { message, position } = useAtomValues(propsAtoms);

  const statusStyles = (
    position === "sent" ? sentBubbleStyles : receivedBubbleStyles
  ).status;

  if (!message) {
    return null;
  }

  if (message.status === MessagingStatus.Sending) {
    return (
      <Loading className={cn("absolute h-6 w-6 text-gray-500", statusStyles)} />
    );
  }

  if (message.status === MessagingStatus.Failed) {
    return (
      <MdError
        onClick={() => onResendMessage?.(message)}
        className={cn(
          "text-destructive absolute h-6 w-6 cursor-pointer",
          statusStyles
        )}
      />
    );
  }

  return null;
}
